(function() {
  'use strict';
  /* gm-community build 20260802-radioclock */

  var RADIO_UNLOCK_STORAGE_KEY = 'gm-radio-unlocked';

  var COMMUNITY_SUPABASE_URL = 'https://tbzlhewcevuyopsytcwi.supabase.co';
  var COMMUNITY_SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InRiemxoZXdjZXZ1eW9wc3l0Y3dpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzkzMTA3MzIsImV4cCI6MjA5NDg4NjczMn0.AgZa1dXiowhgqMlCOSN9EuUpYOkDCitCmvUxsk3C6OA';

  function escHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function formatTime(seconds) {
    if (!isFinite(seconds) || seconds < 0) return '0:00';
    var total = Math.floor(seconds);
    var mins = Math.floor(total / 60);
    var secs = total % 60;
    return mins + ':' + pad(secs);
  }

  function initCommunityPhotos(page) {
    var SUPABASE_URL = 'https://tbzlhewcevuyopsytcwi.supabase.co';
    var SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InRiemxoZXdjZXZ1eW9wc3l0Y3dpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzkzMTA3MzIsImV4cCI6MjA5NDg4NjczMn0.AgZa1dXiowhgqMlCOSN9EuUpYOkDCitCmvUxsk3C6OA';
    var PHOTOS_BUCKET = 'community-photos';
    var PHOTOS_MAX_BYTES = 5 * 1024 * 1024;
    var PHOTOS_ALLOWED_TYPES = {
      'image/jpeg': 'jpg',
      'image/png': 'png',
      'image/webp': 'webp',
      'image/gif': 'gif'
    };
    var PHOTOS_POLL_MS = 30000;

    var gallerySection = page.querySelector('[data-community-gallery]');
    var grid = page.querySelector('[data-community-gallery-grid]');
    var emptyEl = page.querySelector('[data-community-gallery-empty]');
    var addBtn = page.querySelector('[data-community-fitpics-add]');
    var fileInput = page.querySelector('[data-community-fitpics-input]');
    var scrollArea = page.querySelector('.gm-community-gallery-scroll');
    if (!gallerySection || !grid || !addBtn || !fileInput) return;

    var profileHref = gallerySection.getAttribute('data-profile-href') || '/pages/profile';
    var uploading = false;
    var pollTimer = null;
    var scatterLayoutTimer = null;

    var SCATTER_PATTERNS = [
      { scale: 1.06, rot: -3.5, jitter: -4, shiftY: -3 },
      { scale: 1.02, rot: 2.5, jitter: 3, shiftY: 2 },
      { scale: 1.04, rot: -2, jitter: -3, shiftY: -2 },
      { scale: 1.0, rot: 3, jitter: 4, shiftY: 3 },
      { scale: 1.03, rot: -2.5, jitter: -3, shiftY: 2 },
      { scale: 1.05, rot: 1.5, jitter: 3, shiftY: -2 },
      { scale: 1.01, rot: -3, jitter: 3, shiftY: 2 },
      { scale: 1.04, rot: 2, jitter: -3, shiftY: -3 }
    ];
    var SCATTER_GAP_DESKTOP = 8;
    var SCATTER_GAP_MOBILE = 8;
    var SCATTER_COL_GAP_DESKTOP = 0;
    var SCATTER_COL_GAP_MOBILE = 0;
    var SCATTER_OVERLAP_Y = 0.22;
    var SCATTER_BLEED_X = 0.16;
    var SCATTER_WIDTH_MAX = 1.14;
    var SCATTER_TOP_PAD = 6;

    function isScatterMobile() {
      return window.matchMedia('(max-width: 749px)').matches;
    }

    function getScatterColumnCount() {
      if (isScatterMobile()) return 2;
      return 4;
    }

    function openPhotoLightbox(src, alt) {
      if (window.__gmChat && typeof window.__gmChat.openLightbox === 'function') {
        window.__gmChat.openLightbox(src, alt || 'community photo');
        return;
      }
      window.open(src, '_blank', 'noopener,noreferrer');
    }

    function bringPhotoForward(figure) {
      grid.querySelectorAll('.gm-community-photo.is-front').forEach(function(node) {
        node.classList.remove('is-front');
      });
      figure.classList.add('is-front');
    }

    function bindPhotoInteractions(figure, photo) {
      var displayName = getDisplayName(photo);
      figure.setAttribute('role', 'button');
      figure.setAttribute('tabindex', '0');
      figure.setAttribute('aria-label', 'view photo by ' + displayName);

      figure.addEventListener('pointerdown', function() {
        bringPhotoForward(figure);
      });

      figure.addEventListener('click', function(e) {
        e.preventDefault();
        if (!photo || !photo.image_url) return;
        openPhotoLightbox(photo.image_url, displayName);
      });

      figure.addEventListener('keydown', function(e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        e.preventDefault();
        if (!photo || !photo.image_url) return;
        openPhotoLightbox(photo.image_url, displayName);
      });
    }

    function layoutScatterPhotos() {
      if (!grid) return;
      var photos = grid.querySelectorAll('.gm-community-photo');
      if (!photos.length) {
        grid.style.minHeight = '';
        return;
      }

      var containerWidth = grid.clientWidth;
      if (containerWidth <= 0) return;

      var mobile = isScatterMobile();
      var colCount = getScatterColumnCount();
      var verticalGap = mobile ? SCATTER_GAP_MOBILE : SCATTER_GAP_DESKTOP;
      var colWidth = containerWidth / colCount;
      var colStep = colWidth;
      var maxPhotoWidth = Math.round((containerWidth / colCount) * (mobile ? 1.1 : SCATTER_WIDTH_MAX));
      var colHeights = [];
      var c;

      for (c = 0; c < colCount; c++) colHeights[c] = SCATTER_TOP_PAD;

      function shortestColumn() {
        var idx = 0;
        for (var i = 1; i < colCount; i++) {
          if (colHeights[i] < colHeights[idx]) idx = i;
        }
        return idx;
      }

      photos.forEach(function(figure, index) {
        var pattern = SCATTER_PATTERNS[index % SCATTER_PATTERNS.length];
        var col = shortestColumn();
        var width = Math.min(Math.round(colWidth * pattern.scale), maxPhotoWidth);
        var overlapIn = Math.round(width * SCATTER_BLEED_X);
        var left = col * colStep + Math.round((colWidth - width) / 2) + pattern.jitter;
        left = Math.max(col * colStep - overlapIn, Math.min(left, col * colStep + colWidth - width + overlapIn));
        left = Math.max(-overlapIn, Math.min(left, containerWidth - width + overlapIn));
        var top = colHeights[col] + (pattern.shiftY || 0);

        figure.style.width = width + 'px';
        figure.style.left = left + 'px';
        figure.style.top = top + 'px';
        figure.style.transform = 'rotate(' + pattern.rot + 'deg)';
        figure.style.zIndex = String(index + 1);

        var height = figure.offsetHeight;
        var step = Math.round(height * (1 - SCATTER_OVERLAP_Y));
        colHeights[col] += Math.max(step, Math.round(height * 0.62)) + verticalGap;
      });

      var maxBottom = colHeights[0];
      for (c = 1; c < colCount; c++) {
        if (colHeights[c] > maxBottom) maxBottom = colHeights[c];
      }

      grid.style.minHeight = Math.ceil(maxBottom + 28) + 'px';
      updateGalleryViewportHeight();
      notifyGalleryUpdated();
    }

    function updateGalleryViewportHeight() {
      if (!scrollArea || !gallerySection) return;
      if (gallerySection.classList.contains('is-fullscreen')) {
        scrollArea.style.minHeight = '';
        return;
      }

      var photos = grid.querySelectorAll('.gm-community-photo');
      if (!photos.length) {
        scrollArea.style.minHeight = '';
        return;
      }

      var colCount = getScatterColumnCount();
      var rowBottom = 0;
      var count = Math.min(colCount, photos.length);
      var i;

      for (i = 0; i < count; i++) {
        var fig = photos[i];
        var bottom = fig.offsetTop + fig.offsetHeight;
        if (bottom > rowBottom) rowBottom = bottom;
      }

      for (i = 0; i < photos.length; i++) {
        var overlapBottom = photos[i].offsetTop + photos[i].offsetHeight;
        if (overlapBottom > rowBottom && i < colCount * 2) rowBottom = overlapBottom;
      }

      scrollArea.style.minHeight = Math.ceil(rowBottom + 64) + 'px';
    }

    function scheduleScatterLayout() {
      if (scatterLayoutTimer) window.clearTimeout(scatterLayoutTimer);
      scatterLayoutTimer = window.setTimeout(function() {
        scatterLayoutTimer = null;
        layoutScatterPhotos();
      }, 50);
    }

    function getAuth() {
      return window.__gmAuth || null;
    }

    function getCurrentUser() {
      var auth = getAuth();
      return auth && typeof auth.getCurrentUser === 'function' ? auth.getCurrentUser() : null;
    }

    async function getValidAccessToken() {
      var auth = getAuth();
      if (auth && typeof auth.getValidAccessToken === 'function') {
        return auth.getValidAccessToken();
      }
      return null;
    }

    function getDisplayName(photo) {
      if (photo.profiles && photo.profiles.username) return photo.profiles.username;
      var user = getCurrentUser();
      if (user && photo.user_id === user.id) {
        var meta = user.user_metadata || {};
        if (meta.username) return meta.username;
      }
      return 'anonymous';
    }

    function notifyGalleryUpdated() {
      if (!scrollArea) return;
      window.setTimeout(function() {
        scrollArea.dispatchEvent(new Event('scroll'));
      }, 0);
      window.setTimeout(function() {
        scrollArea.dispatchEvent(new Event('scroll'));
      }, 250);
    }

    function renderPhotos(photos) {
      var items = Array.isArray(photos) ? photos : [];
      grid.querySelectorAll('.gm-community-photo').forEach(function(node) {
        node.remove();
      });

      if (!items.length) {
        grid.classList.remove('is-scatter');
        grid.style.minHeight = '';
        if (scrollArea) scrollArea.style.minHeight = '';
        if (emptyEl) emptyEl.hidden = false;
        notifyGalleryUpdated();
        return;
      }

      if (emptyEl) emptyEl.hidden = true;
      grid.classList.add('is-scatter');

      var pendingLoads = 0;

      items.forEach(function(photo) {
        if (!photo || !photo.image_url) return;

        var figure = document.createElement('figure');
        figure.className = 'gm-community-photo';
        figure.dataset.photoId = photo.id || '';

        var img = document.createElement('img');
        img.src = photo.image_url;
        img.alt = '';
        img.loading = 'lazy';
        pendingLoads += 1;
        img.addEventListener('load', function onPhotoLoad() {
          img.removeEventListener('load', onPhotoLoad);
          pendingLoads -= 1;
          scheduleScatterLayout();
        });
        img.addEventListener('error', function onPhotoError() {
          img.removeEventListener('error', onPhotoError);
          pendingLoads -= 1;
          scheduleScatterLayout();
        });
        if (img.complete) {
          pendingLoads -= 1;
        }

        var caption = document.createElement('figcaption');
        caption.className = 'gm-community-photo-user';
        caption.textContent = getDisplayName(photo);

        figure.appendChild(img);
        figure.appendChild(caption);
        bindPhotoInteractions(figure, photo);
        grid.appendChild(figure);
      });

      scheduleScatterLayout();
    }

    async function loadPhotos(silent) {
      try {
        var res = await fetch(
          SUPABASE_URL + '/rest/v1/community_photos?is_deleted=eq.false&order=created_at.desc&select=*,profiles!community_photos_user_id_fkey(username)',
          { headers: { apikey: SUPABASE_ANON_KEY, Authorization: 'Bearer ' + SUPABASE_ANON_KEY } }
        );
        var data = await res.json();
        if (!Array.isArray(data)) {
          if (!silent) renderPhotos([]);
          return;
        }
        renderPhotos(data);
      } catch (e) {
        if (!silent) console.error('community photos load error', e);
      }
    }

    function getPhotoExtension(mime) {
      return PHOTOS_ALLOWED_TYPES[mime] || 'jpg';
    }

    function resolvePhotoMime(file) {
      var mime = file.type || '';
      if (mime === 'image/jpg') mime = 'image/jpeg';
      if (mime && PHOTOS_ALLOWED_TYPES[mime]) return mime;

      var name = String(file.name || '').toLowerCase();
      if (name.endsWith('.jpg') || name.endsWith('.jpeg')) return 'image/jpeg';
      if (name.endsWith('.png')) return 'image/png';
      if (name.endsWith('.webp')) return 'image/webp';
      if (name.endsWith('.gif')) return 'image/gif';
      return mime;
    }

    async function uploadPhotoFile(file, token, userId, mime) {
      var ext = getPhotoExtension(mime);
      var path = userId + '/' + Date.now() + '-' + Math.random().toString(36).slice(2, 10) + '.' + ext;
      var uploadRes = await fetch(SUPABASE_URL + '/storage/v1/object/' + PHOTOS_BUCKET + '/' + path, {
        method: 'POST',
        headers: {
          Authorization: 'Bearer ' + token,
          apikey: SUPABASE_ANON_KEY,
          'Content-Type': mime,
          'Cache-Control': '3600',
          'x-upsert': 'false'
        },
        body: file
      });
      if (!uploadRes.ok) {
        var uploadErr = await uploadRes.text();
        throw new Error('upload failed (' + uploadRes.status + '): ' + uploadErr);
      }

      var imageUrl = SUPABASE_URL + '/storage/v1/object/public/' + PHOTOS_BUCKET + '/' + path;
      var insertRes = await fetch(SUPABASE_URL + '/rest/v1/community_photos', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          apikey: SUPABASE_ANON_KEY,
          Authorization: 'Bearer ' + token,
          Prefer: 'return=minimal'
        },
        body: JSON.stringify({
          user_id: userId,
          image_url: imageUrl
        })
      });
      if (!insertRes.ok) {
        var insertErr = await insertRes.text();
        throw new Error('save failed (' + insertRes.status + '): ' + insertErr);
      }
    }

    async function handleFilesSelected(event) {
      var files = event.target.files ? Array.prototype.slice.call(event.target.files) : [];
      event.target.value = '';
      if (!files.length || uploading) return;

      var user = getCurrentUser();
      if (!user) {
        window.location.href = profileHref;
        return;
      }

      var token = await getValidAccessToken();
      if (!token) {
        window.location.href = profileHref;
        return;
      }

      uploading = true;
      addBtn.classList.add('is-uploading');
      addBtn.textContent = 'uploading…';

      var uploaded = 0;
      var failed = 0;

      for (var i = 0; i < files.length; i++) {
        var file = files[i];
        var mime = resolvePhotoMime(file);
        if (!PHOTOS_ALLOWED_TYPES[mime]) {
          failed += 1;
          continue;
        }
        if (file.size > PHOTOS_MAX_BYTES) {
          failed += 1;
          continue;
        }
        try {
          await uploadPhotoFile(file, token, user.id, mime);
          uploaded += 1;
        } catch (e) {
          failed += 1;
          console.error('community photo upload', e);
        }
      }

      uploading = false;
      addBtn.classList.remove('is-uploading');
      addBtn.textContent = 'add your own photos';

      if (uploaded > 0) {
        await loadPhotos(true);
      } else if (failed > 0) {
        window.alert('could not upload — use jpeg, png, webp, or gif under 5mb');
      }
    }

    addBtn.addEventListener('click', function() {
      addBtn.blur();
      if (uploading) return;
      if (!getCurrentUser()) {
        window.location.href = profileHref;
        return;
      }
      fileInput.click();
    });

    fileInput.addEventListener('change', handleFilesSelected);

    window.addEventListener('resize', scheduleScatterLayout);
    if (typeof ResizeObserver === 'function') {
      var scatterObserver = new ResizeObserver(scheduleScatterLayout);
      scatterObserver.observe(grid);
    }
    if (gallerySection && typeof MutationObserver === 'function') {
      var galleryPanelObserver = new MutationObserver(function() {
        if (gallerySection.classList.contains('is-fullscreen')) {
          scheduleScatterLayout();
          window.setTimeout(scheduleScatterLayout, 120);
        }
      });
      galleryPanelObserver.observe(gallerySection, { attributes: true, attributeFilter: ['class'] });
    }

    window.addEventListener('gm-auth-change', function() {
      loadPhotos(true);
    });

    loadPhotos(false);
    pollTimer = window.setInterval(function() {
      loadPhotos(true);
    }, PHOTOS_POLL_MS);
  }

  function resetRadioProgress(root) {
    var progressFill = root.querySelector('[data-radio-progress-fill]');
    var elapsedEl = root.querySelector('[data-radio-elapsed]');
    var durationEl = root.querySelector('[data-radio-duration]');
    if (progressFill) progressFill.style.width = '0%';
    if (elapsedEl) elapsedEl.textContent = '0:00';
    if (durationEl) durationEl.textContent = '0:00';
  }

  async function initCommunityRadio(root) {
    var audio = root.querySelector('[data-radio-audio]');
    var muteBtn = root.querySelector('[data-radio-mute]');
    var queueToggle = root.querySelector('[data-radio-queue-toggle]');
    var queuePanel = root.querySelector('[data-radio-queue]');
    var progressFill = root.querySelector('[data-radio-progress-fill]');
    var elapsedEl = root.querySelector('[data-radio-elapsed]');
    var durationEl = root.querySelector('[data-radio-duration]');
    var listenOverlay = root.querySelector('[data-radio-listen]');
    var clock = null;
    var currentTrackId = '';
    var currentAudioUrl = '';
    var syncing = false;
    var pollTimer = null;
    var progressTimer = null;
    var durationReported = false;
    var lastSeekMs = 0;
    var syncedTrackId = '';
    var audioUnlocked = false;
    var pendingPlayToken = 0;
    var radioStarted = false;
    var trackLoadedAt = 0;
    var endSyncMinDelayMs = 12000;

    resetRadioProgress(root);

    function resetClockToStart() {
      if (!clock) return;
      clock.basePosition = 0;
      clock.serverMs = Date.now();
    }

    function setMuteUi(muted) {
      if (!muteBtn) return;
      muteBtn.setAttribute('aria-pressed', muted ? 'true' : 'false');
      muteBtn.setAttribute('aria-label', muted ? 'unmute' : 'mute');
    }

    function showListenOverlay() {
      root.classList.add('is-awaiting-listen');
      if (listenOverlay) listenOverlay.hidden = false;
    }

    function hideListenOverlay() {
      root.classList.remove('is-awaiting-listen');
      if (listenOverlay) listenOverlay.hidden = true;
    }

    function syncToLivePosition() {
      if (!audio || !clock) return;
      var target = getExpectedPosition();
      if (target <= 1.5) return;
      try {
        audio.currentTime = target;
        lastSeekMs = Date.now();
      } catch (e) {
        /* ignore */
      }
      updateProgress();
    }

    function unlockRadio() {
      if (!audio) return;
      markAudioUnlocked();
      audio.muted = false;
      setMuteUi(false);
      hideListenOverlay();
      try {
        localStorage.setItem(RADIO_UNLOCK_STORAGE_KEY, '1');
      } catch (e) {
        /* ignore */
      }
      syncToLivePosition();
      tryStartPlayback(true);
    }

    function hasStoredRadioUnlock() {
      try {
        return localStorage.getItem(RADIO_UNLOCK_STORAGE_KEY) === '1';
      } catch (e) {
        return false;
      }
    }

    function waitForRadioReady(timeoutMs) {
      return new Promise(function(resolve) {
        if (!audio) {
          resolve(false);
          return;
        }
        if (audio.readyState >= 2 && currentAudioUrl) {
          resolve(true);
          return;
        }
        var settled = false;
        function finish(ok) {
          if (settled) return;
          settled = true;
          audio.removeEventListener('canplay', onCanPlay);
          resolve(ok);
        }
        function onCanPlay() {
          finish(!!currentAudioUrl);
        }
        audio.addEventListener('canplay', onCanPlay);
        window.setTimeout(function() {
          finish(!!(audio && audio.readyState >= 2 && currentAudioUrl));
        }, timeoutMs || 8000);
      });
    }

    async function initListenPrompt() {
      if (!hasStoredRadioUnlock()) {
        showListenOverlay();
        return;
      }

      var ready = await waitForRadioReady(8000);
      if (!ready || !audio || !currentAudioUrl) {
        showListenOverlay();
        return;
      }

      markAudioUnlocked();
      syncToLivePosition();
      try {
        await audio.play();
        hideListenOverlay();
      } catch (e) {
        audioUnlocked = false;
        if (audio) audio.muted = false;
        setMuteUi(false);
        showListenOverlay();
      }
    }

    function getExpectedPosition() {
      if (!clock) return 0;
      var pos = clock.expectedPosition();
      if (clock.duration > 0) pos = Math.min(pos, clock.duration - 0.25);
      return Math.max(0, pos);
    }

    function getTrackDuration() {
      if (clock && clock.duration > 0) return clock.duration;
      if (audio && isFinite(audio.duration) && audio.duration > 0) return audio.duration;
      return 0;
    }

    function getDisplayPosition() {
      if (audio && isFinite(audio.currentTime) && audio.currentTime >= 0) {
        return audio.currentTime;
      }
      return getExpectedPosition();
    }

    function updateProgress() {
      if (!progressFill) return;
      var duration = getTrackDuration();
      var current = getDisplayPosition();
      if (!isFinite(duration) || duration <= 0) return;

      current = Math.max(0, Math.min(current, duration));
      var remaining = Math.max(0, duration - current);

      progressFill.style.width = ((current / duration) * 100) + '%';
      if (elapsedEl) elapsedEl.textContent = formatTime(current);
      if (durationEl) durationEl.textContent = formatTime(remaining);
    }

    function tryStartPlayback(fromGesture) {
      if (!audio || !currentAudioUrl) return;
      if (!audioUnlocked && !fromGesture) return;
      if (!fromGesture && !audio.paused) return;

      if (fromGesture) markAudioUnlocked();
      setMuteUi(!!audio.muted);

      var playAttempt = audio.play();
      if (!playAttempt || typeof playAttempt.catch !== 'function') return;

      playAttempt.catch(function() {
        if (fromGesture) return;
        if (!audioUnlocked) {
          showListenOverlay();
          return;
        }
        showListenOverlay();
      });
    }

    function seekToClock(force) {
      if (!audio || !clock) return false;
      var target = getExpectedPosition();
      var drift = Math.abs(audio.currentTime - target);
      if (!force && drift <= RADIO_RESYNC_THRESHOLD) return false;

      var now = Date.now();
      if (!force && now - lastSeekMs < RADIO_MIN_SEEK_GAP_MS) return false;

      try {
        audio.currentTime = target;
        lastSeekMs = now;
        updateProgress();
        return true;
      } catch (e) {
        return false;
      }
    }

    function playFromStart(mode) {
      if (!audio || !clock) return;
      var token = ++pendingPlayToken;

      function isStale() {
        return token !== pendingPlayToken;
      }

      function startPlayback() {
        if (isStale()) return;
        if (!audioUnlocked) return;
        setMuteUi(!!audio.muted);
        tryStartPlayback(false);
      }

      function startWhenReady() {
        if (isStale()) return;
        if (audio.readyState >= 2) {
          startPlayback();
          return;
        }
        audio.addEventListener('canplay', function onCanPlay() {
          audio.removeEventListener('canplay', onCanPlay);
          startPlayback();
        });
      }

      if (mode === 'fresh-track') {
        resetClockToStart();
      }

      try {
        audio.currentTime = 0;
      } catch (e) {
        /* ignore */
      }
      lastSeekMs = Date.now();
      updateProgress();
      startWhenReady();

      if (mode === 'join' && audioUnlocked) {
        var target = getExpectedPosition();
        if (target > 1.5) {
          function seekToLive() {
            if (isStale()) return;
            syncToLivePosition();
          }
          if (audio.readyState >= 4) {
            seekToLive();
          } else {
            audio.addEventListener('canplaythrough', function onBuffered() {
              audio.removeEventListener('canplaythrough', onBuffered);
              seekToLive();
            });
          }
        }
      }
    }

    function markAudioUnlocked() {
      audioUnlocked = true;
    }

    function maybeReportDuration() {
      if (!clock || !clock.trackId || durationReported || !audio) return;
      var duration = audio.duration;
      if (!isFinite(duration) || duration < 30) return;
      durationReported = true;
      reportRadioTrackDuration(clock.trackId, duration);
    }

    function markTrackLoaded() {
      trackLoadedAt = Date.now();
    }

    function canQueueEndSync() {
      return Date.now() - trackLoadedAt >= endSyncMinDelayMs;
    }

    async function loadTrackFromState(state) {
      if (!audio || !state || !state.audio_url) return;
      applyRadioNowPlaying(root, state);
      clock = createRadioClock(state);
      currentTrackId = state.track_id || '';
      durationReported = false;
      syncedTrackId = '';
      markTrackLoaded();

      if (currentAudioUrl !== state.audio_url) {
        pendingPlayToken += 1;
        currentAudioUrl = state.audio_url;
        audio.src = currentAudioUrl;
        audio.load();
      } else if (clock.basePosition > 1.5) {
        playFromStart('join');
      } else {
        playFromStart('fresh-track');
      }
    }

    var endSyncQueued = false;

    function queueEndSync() {
      if (endSyncQueued || syncing || !canQueueEndSync()) return;
      endSyncQueued = true;
      window.setTimeout(function() {
        endSyncQueued = false;
        syncRadio(false);
      }, 200);
    }

    async function syncRadio(isInitial) {
      if (syncing) return;
      syncing = true;
      try {
        var state = await fetchRadioNowPlaying();
        if (!state || !state.ok || !state.audio_url) return;

        if (!clock || state.track_id !== currentTrackId || currentAudioUrl !== state.audio_url) {
          await loadTrackFromState(state);
        } else {
          clock.refresh(state);
          applyRadioNowPlaying(root, state);
          updateProgress();
          var didSeek = isInitial ? seekToClock(true) : seekToClock(false);
          if (audioUnlocked && (didSeek || (audio && audio.paused))) {
            tryStartPlayback(false);
          }
        }
      } catch (e) {
        /* ignore */
      } finally {
        syncing = false;
      }
    }

    if (audio) {
      audio.preload = 'auto';
      audio.setAttribute('playsinline', '');
      audio.addEventListener('loadedmetadata', function() {
        maybeReportDuration();
        if (clock && clock.trackId && clock.trackId !== syncedTrackId) {
          var mode = radioStarted ? 'fresh-track' : 'join';
          radioStarted = true;
          syncedTrackId = clock.trackId;
          markTrackLoaded();
          playFromStart(mode);
        }
        updateProgress();
      });
      audio.addEventListener('durationchange', function() {
        maybeReportDuration();
        updateProgress();
      });
      audio.addEventListener('timeupdate', function() {
        updateProgress();
        if (!clock || syncing) return;
        var duration = getTrackDuration();
        var remaining = duration - getDisplayPosition();
        if (isFinite(duration) && duration > 0 && remaining <= RADIO_END_SYNC_LEAD) {
          queueEndSync();
        }
      });
      audio.addEventListener('playing', updateProgress);
      audio.addEventListener('ended', queueEndSync);
    }

    await syncRadio(true);
    updateProgress();
    await initListenPrompt();

    pollTimer = window.setInterval(function() {
      syncRadio(false);
    }, RADIO_SYNC_POLL_MS);

    progressTimer = window.setInterval(updateProgress, 500);

    if (listenOverlay) {
      listenOverlay.addEventListener('click', function() {
        unlockRadio();
      });
    }

    if (muteBtn) {
      muteBtn.addEventListener('click', function() {
        if (!audio) return;
        var nextMuted = !audio.muted;
        if (!nextMuted && !audioUnlocked) {
          unlockRadio();
          return;
        }
        audio.muted = nextMuted;
        setMuteUi(nextMuted);
        if (!nextMuted) markAudioUnlocked();
        if (!nextMuted) tryStartPlayback(true);
      });
    }

    if (queueToggle && queuePanel) {
      queueToggle.addEventListener('click', function() {
        var isOpen = !queuePanel.hasAttribute('hidden');
        if (isOpen) {
          queuePanel.setAttribute('hidden', 'hidden');
          queueToggle.setAttribute('aria-expanded', 'false');
          queueToggle.setAttribute('aria-label', 'show queue');
        } else {
          queuePanel.removeAttribute('hidden');
          queueToggle.setAttribute('aria-expanded', 'true');
          queueToggle.setAttribute('aria-label', 'hide queue');
          fetchRadioNowPlaying().then(function(state) {
            if (state && state.ok) applyRadioNowPlaying(root, state);
          }).catch(function() { /* ignore */ });
        }
      });
    }
  }

  function formatRelativePostedDate(isoDate) {
    var posted = new Date(isoDate);
    if (isNaN(posted.getTime())) return isoDate;

    var months = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
    function absoluteDate() {
      return months[posted.getMonth()] + ' ' + posted.getDate() + ', ' + posted.getFullYear();
    }

    var now = new Date();
    var postedDay = new Date(posted.getFullYear(), posted.getMonth(), posted.getDate());
    var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    var diffDays = Math.round((today - postedDay) / 86400000);

    if (diffDays < 0) return absoluteDate();
    if (diffDays === 0) return 'today';
    if (diffDays === 1) return '1 day ago';
    if (diffDays < 7) return diffDays + ' days ago';

    return absoluteDate();
  }

  function initAnnouncementDates(page) {
    var dates = page.querySelectorAll('[data-posted-at]');
    dates.forEach(function(el) {
      var isoDate = el.getAttribute('data-posted-at');
      if (!isoDate) return;
      el.textContent = formatRelativePostedDate(isoDate);
    });
  }

  async function initCommunityAnnouncements(page) {
    var list = page.querySelector('[data-community-announcements-list]');
    if (!list) return;
    try {
      var res = await fetch(
        COMMUNITY_SUPABASE_URL + '/rest/v1/community_announcements?is_deleted=eq.false&order=posted_at.desc&limit=20',
        {
          headers: {
            apikey: COMMUNITY_SUPABASE_ANON_KEY,
            Authorization: 'Bearer ' + COMMUNITY_SUPABASE_ANON_KEY
          }
        }
      );
      var rows = await res.json();
      if (!Array.isArray(rows) || !rows.length) {
        list.innerHTML = '<li class="gm-community-announcement-item"><span class="gm-community-announcement-text">no announcements yet</span></li>';
        return;
      }
      list.innerHTML = rows.map(function(row) {
        var postedAt = row.posted_at || row.created_at || '';
        return '<li class="gm-community-announcement-item">' +
          '<span class="gm-community-announcement-date" data-posted-at="' + escHtml(postedAt) + '"></span>' +
          '<span class="gm-community-announcement-text">' + escHtml(row.body) + '</span>' +
        '</li>';
      }).join('');
      initAnnouncementDates(page);
      var area = page.querySelector('.gm-community-announcements-body');
      if (area) {
        window.setTimeout(function() {
          area.dispatchEvent(new Event('scroll'));
        }, 0);
      }
      if (typeof page.__gmSyncAnnouncementHeight === 'function') {
        page.__gmSyncAnnouncementHeight();
      }
    } catch (e) {
      list.innerHTML = '<li class="gm-community-announcement-item"><span class="gm-community-announcement-text">could not load announcements</span></li>';
    }
  }

  var RADIO_SYNC_POLL_MS = 3000;
  var RADIO_RESYNC_THRESHOLD = 15;
  var RADIO_MIN_SEEK_GAP_MS = 8000;
  var RADIO_END_SYNC_LEAD = 4;

  async function fetchRadioNowPlaying() {
    var res = await fetch(
      COMMUNITY_SUPABASE_URL + '/rest/v1/rpc/get_radio_now_playing',
      {
        method: 'POST',
        headers: {
          apikey: COMMUNITY_SUPABASE_ANON_KEY,
          Authorization: 'Bearer ' + COMMUNITY_SUPABASE_ANON_KEY,
          'Content-Type': 'application/json'
        },
        body: '{}'
      }
    );
    var data = await res.json();
    if (!data || data.ok === false) return null;
    return sanitizeRadioState(data);
  }

  function sanitizeRadioState(state) {
    if (!state || !state.ok) return state;
    var duration = Number(state.duration_seconds) || 0;
    var position = Number(state.position_seconds) || 0;
    if (duration > 0 && position >= duration) {
      state.position_seconds = position % duration;
    }
    return state;
  }

  function reportRadioTrackDuration(trackId, durationSeconds) {
    if (!trackId || !isFinite(durationSeconds) || durationSeconds < 30) return;
    fetch(
      COMMUNITY_SUPABASE_URL + '/rest/v1/rpc/report_radio_track_duration',
      {
        method: 'POST',
        headers: {
          apikey: COMMUNITY_SUPABASE_ANON_KEY,
          Authorization: 'Bearer ' + COMMUNITY_SUPABASE_ANON_KEY,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          p_track_id: trackId,
          p_duration_seconds: Math.round(durationSeconds)
        })
      }
    ).catch(function() { /* ignore */ });
  }

  function createRadioClock(state) {
    state = sanitizeRadioState(state);
    var serverMs = Date.parse(state.server_time || '') || Date.now();
    var duration = Number(state.duration_seconds) || 0;
    var position = Number(state.position_seconds) || 0;
    if (duration > 0) position = Math.max(0, Math.min(position, duration - 0.25));
    return {
      trackId: state.track_id,
      basePosition: position,
      serverMs: serverMs,
      duration: duration,
      expectedPosition: function() {
        return this.basePosition + (Date.now() - this.serverMs) / 1000;
      },
      refresh: function(nextState) {
        nextState = sanitizeRadioState(nextState);
        this.trackId = nextState.track_id;
        var nextDuration = Number(nextState.duration_seconds) || 0;
        var nextPosition = Number(nextState.position_seconds) || 0;
        if (nextDuration > 0) nextPosition = Math.max(0, Math.min(nextPosition, nextDuration - 0.25));
        this.basePosition = nextPosition;
        this.serverMs = Date.parse(nextState.server_time || '') || Date.now();
        this.duration = nextDuration;
      }
    };
  }

  function setRadioCover(root, url, alt) {
    var cover = root.querySelector('[data-radio-cover]');
    var placeholder = root.querySelector('[data-radio-cover-placeholder]');
    if (!cover) return;
    if (url) {
      cover.src = url;
      cover.alt = alt || '';
      cover.hidden = false;
      if (placeholder) placeholder.hidden = true;
    } else {
      cover.removeAttribute('src');
      cover.hidden = true;
      if (placeholder) placeholder.hidden = false;
    }
  }

  function orderRadioQueueTracks(queue, currentTrackId) {
    if (!Array.isArray(queue) || !queue.length) return [];

    var currentIndex = 0;
    for (var i = 0; i < queue.length; i++) {
      if (currentTrackId && queue[i].id === currentTrackId) {
        currentIndex = i;
        break;
      }
      if (queue[i].is_current) {
        currentIndex = i;
        break;
      }
    }

    return queue.slice(currentIndex).concat(queue.slice(0, currentIndex));
  }

  function applyRadioNowPlaying(root, state) {
    if (!state || !state.ok) return false;
    var titleEl = root.querySelector('[data-radio-track-title]');
    var artistEl = root.querySelector('[data-radio-track-artist]');
    var queueList = root.querySelector('[data-radio-queue-list]');

    if (titleEl) titleEl.textContent = state.title || titleEl.textContent;
    if (artistEl) artistEl.textContent = state.artist || artistEl.textContent;
    setRadioCover(root, state.cover_url, state.title);
    if (queueList && Array.isArray(state.queue)) {
      var orderedQueue = orderRadioQueueTracks(state.queue, state.track_id);
      queueList.innerHTML = orderedQueue.map(function(track, index) {
        return '<li class="gm-community-radio-queue-item' + (index === 0 ? ' is-current' : '') + '">' +
          '<span class="gm-community-radio-queue-title">' + escHtml(track.title) + '</span>' +
          '<span class="gm-community-radio-queue-artist">' + escHtml(track.artist) + '</span>' +
        '</li>';
      }).join('');
    }
    return !!state.audio_url;
  }

  function initScrollAreas(page) {
    var areas = page.querySelectorAll('.gm-community-scroll-area');
    areas.forEach(function(area) {
      if (area.dataset.scrollReady === 'true') return;

      area.dataset.scrollReady = 'true';

      var wrap = document.createElement('div');
      wrap.className = 'gm-community-scroll-wrap';
      area.parentNode.insertBefore(wrap, area);
      wrap.appendChild(area);

      var rail = document.createElement('div');
      rail.className = 'gm-community-scroll-rail';
      rail.setAttribute('aria-hidden', 'true');

      var thumb = document.createElement('div');
      thumb.className = 'gm-community-scroll-thumb';
      thumb.appendChild(document.createTextNode('\u200b'));
      rail.appendChild(thumb);
      wrap.appendChild(rail);

      var dragging = false;
      var dragStartY = 0;
      var dragStartScroll = 0;

      function canScroll() {
        return area.scrollHeight > area.clientHeight + 1;
      }

      function thumbMetrics() {
        var view = area.clientHeight;
        var total = area.scrollHeight;
        var railHeight = rail.clientHeight || view;
        var thumbHeight = Math.max(32, Math.round(railHeight * (view / total)));
        var maxTop = Math.max(railHeight - thumbHeight, 0);
        return { view: view, total: total, thumbHeight: thumbHeight, maxTop: maxTop };
      }

      function updateThumb() {
        if (!canScroll()) {
          wrap.classList.remove('is-scroll-active');
          wrap.classList.add('is-scroll-hidden');
          return;
        }

        wrap.classList.remove('is-scroll-hidden');
        wrap.classList.add('is-scroll-active');
        var metrics = thumbMetrics();
        var top = metrics.maxTop <= 0
          ? 0
          : (area.scrollTop / (metrics.total - metrics.view)) * metrics.maxTop;
        thumb.style.height = metrics.thumbHeight + 'px';
        thumb.style.transform = 'translateY(' + top + 'px)';
      }

      function setNear(isNear) {
        wrap.classList.toggle('is-scroll-near', isNear);
      }

      function updateNearFromEvent(e) {
        if (!canScroll()) return;
        var rect = wrap.getBoundingClientRect();
        setNear(rect.right - e.clientX <= 28);
      }

      ['mouseenter', 'mousemove'].forEach(function(eventName) {
        wrap.addEventListener(eventName, updateNearFromEvent);
        area.addEventListener(eventName, updateNearFromEvent);
      });

      rail.addEventListener('mouseenter', function() {
        if (canScroll()) setNear(true);
      });

      rail.addEventListener('mouseleave', function() {
        setNear(false);
      });

      wrap.addEventListener('mouseleave', function(e) {
        if (!wrap.contains(e.relatedTarget)) setNear(false);
      });

      area.addEventListener('scroll', updateThumb);

      thumb.addEventListener('mousedown', function(e) {
        dragging = true;
        dragStartY = e.clientY;
        dragStartScroll = area.scrollTop;
        wrap.classList.add('is-scroll-dragging');
        e.preventDefault();
      });

      rail.addEventListener('mousedown', function(e) {
        if (e.target === thumb) return;
        var rect = rail.getBoundingClientRect();
        var metrics = thumbMetrics();
        var clickY = e.clientY - rect.top;
        var targetTop = Math.min(Math.max(clickY - metrics.thumbHeight / 2, 0), metrics.maxTop);
        area.scrollTop = metrics.maxTop <= 0
          ? 0
          : (targetTop / metrics.maxTop) * (metrics.total - metrics.view);
        e.preventDefault();
      });

      window.addEventListener('mousemove', function(e) {
        if (!dragging) return;
        var metrics = thumbMetrics();
        if (metrics.maxTop <= 0) return;
        var deltaY = e.clientY - dragStartY;
        area.scrollTop = dragStartScroll + (deltaY / metrics.maxTop) * (metrics.total - metrics.view);
      });

      window.addEventListener('mouseup', function() {
        if (!dragging) return;
        dragging = false;
        wrap.classList.remove('is-scroll-dragging');
      });

      window.addEventListener('resize', updateThumb);
      if (window.ResizeObserver) {
        var observer = new ResizeObserver(updateThumb);
        observer.observe(area);
      }

      window.setTimeout(updateThumb, 0);
      window.setTimeout(updateThumb, 250);
    });
  }

  function initCommunityFullscreen(page) {
    function refreshPanelScroll(panel) {
      if (!panel) return;
      panel.querySelectorAll('.gm-community-scroll-area').forEach(function(area) {
        area.dispatchEvent(new Event('scroll'));
      });
      var chatFeed = panel.querySelector('.gm-community-chat-feed');
      if (chatFeed) {
        chatFeed.scrollTop = chatFeed.scrollHeight;
      }
    }

    function syncChatAfterPanelChange(panel) {
      if (!panel || !panel.classList.contains('gm-community-chat')) return;
      var chat = panel._gmChatInstance;
      if (!chat || typeof chat.onPanelFullscreenChange !== 'function') return;
      chat.onPanelFullscreenChange();
      window.setTimeout(function() {
        chat.onPanelFullscreenChange();
      }, 120);
      window.setTimeout(function() {
        chat.onPanelFullscreenChange();
      }, 320);
    }

    function closePanel(panel) {
      if (!panel) return;
      panel.classList.remove('is-fullscreen');
      var btn = panel.querySelector('[data-gm-community-expand]');
      if (btn) {
        btn.setAttribute('aria-expanded', 'false');
        btn.setAttribute('aria-label', 'Open full screen');
        btn.setAttribute('title', 'Expand');
      }
      if (!page.querySelector('.gm-community-chat.is-fullscreen, .gm-community-gallery.is-fullscreen')) {
        document.body.classList.remove('gm-community-panel-fullscreen');
      }
      window.dispatchEvent(new Event('resize'));
      window.setTimeout(function() {
        window.dispatchEvent(new Event('resize'));
        refreshPanelScroll(panel);
        syncChatAfterPanelChange(panel);
      }, 100);
    }

    function openPanel(panel, btn) {
      page.querySelectorAll('.gm-community-chat.is-fullscreen, .gm-community-gallery.is-fullscreen').forEach(function(other) {
        if (other !== panel) closePanel(other);
      });
      panel.classList.add('is-fullscreen');
      document.body.classList.add('gm-community-panel-fullscreen');
      if (btn) {
        btn.setAttribute('aria-expanded', 'true');
        btn.setAttribute('aria-label', 'Exit full screen');
        btn.setAttribute('title', 'Collapse');
      }
      window.dispatchEvent(new Event('resize'));
      window.setTimeout(function() {
        window.dispatchEvent(new Event('resize'));
        refreshPanelScroll(panel);
        syncChatAfterPanelChange(panel);
      }, 100);
    }

    page.querySelectorAll('[data-gm-community-expand]').forEach(function(btn) {
      var panel = btn.closest('.gm-community-chat, .gm-community-gallery');
      if (!panel) return;

      btn.setAttribute('title', 'Expand');

      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        if (panel.classList.contains('is-fullscreen')) closePanel(panel);
        else openPanel(panel, btn);
      });
    });

    document.addEventListener('keydown', function(e) {
      if (e.key !== 'Escape') return;
      if (document.body.classList.contains('gm-chat-lightbox-open')) return;
      var openPanelEl = page.querySelector('.gm-community-chat.is-fullscreen, .gm-community-gallery.is-fullscreen');
      if (openPanelEl) closePanel(openPanelEl);
    });

    window.addEventListener('resize', function() {
      var openPanelEl = page.querySelector('.gm-community-chat.is-fullscreen, .gm-community-gallery.is-fullscreen');
      if (openPanelEl) refreshPanelScroll(openPanelEl);
    });
  }

  function initChatHeight(page) {
    var sidebar = page.querySelector('.gm-community-sidebar');
    var chatCol = page.querySelector('.gm-community-chat-col');
    if (!sidebar || !chatCol) return;

    function sync() {
      if (window.matchMedia('(max-width: 899px)').matches) {
        chatCol.style.height = '';
        chatCol.style.maxHeight = '';
        return;
      }
      var height = sidebar.offsetHeight;
      chatCol.style.height = height + 'px';
      chatCol.style.maxHeight = height + 'px';
    }

    sync();
    window.addEventListener('resize', sync);
    window.setTimeout(sync, 0);
    window.setTimeout(sync, 300);

    if (window.ResizeObserver) {
      var observer = new ResizeObserver(sync);
      observer.observe(sidebar);
    }
  }

  function initAnnouncementHeight(page) {
    var announcements = page.querySelector('.gm-community-announcements');
    var radio = page.querySelector('.gm-community-radio');
    if (!announcements || !radio) return;

    function sync() {
      if (!window.matchMedia('(max-width: 899px)').matches) {
        announcements.style.height = '';
        announcements.style.maxHeight = '';
        return;
      }

      announcements.style.height = '';
      announcements.style.maxHeight = '';
      var height = Math.round(radio.getBoundingClientRect().height);
      if (height > 0) {
        announcements.style.height = height + 'px';
        announcements.style.maxHeight = height + 'px';
      }

      var area = announcements.querySelector('.gm-community-scroll-area');
      if (area) {
        area.dispatchEvent(new Event('scroll'));
      }
    }

    page.__gmSyncAnnouncementHeight = sync;
    sync();
    window.addEventListener('resize', sync);
    [0, 120, 400, 900].forEach(function(ms) {
      window.setTimeout(sync, ms);
    });

    if (window.ResizeObserver) {
      var observer = new ResizeObserver(sync);
      observer.observe(radio);
    }
  }

  document.addEventListener('DOMContentLoaded', function() {
    var page = document.querySelector('.gm-community-page');
    if (!page) return;

    initAnnouncementDates(page);
    initCommunityAnnouncements(page);
    initCommunityPhotos(page);
    initScrollAreas(page);
    initCommunityFullscreen(page);
    initChatHeight(page);
    initAnnouncementHeight(page);

    window.addEventListener('gm-chat-rendered', function(e) {
      if (!e.detail || !e.detail.root || !page.contains(e.detail.root)) return;
      var feed = e.detail.root.querySelector('.gm-community-scroll-area');
      if (!feed) return;
      window.setTimeout(function() {
        feed.dispatchEvent(new Event('scroll'));
      }, 0);
      window.setTimeout(function() {
        feed.dispatchEvent(new Event('scroll'));
      }, 200);
    });

    var radio = page.querySelector('[data-community-radio]');
    if (radio) initCommunityRadio(radio);
  });
})();
